import { isAllQuarters } from '@/api/hcp/partnerscore/utils/partnerScoreUtils';
import { sortByYearQuarter } from '@/api/hcp/partnerscore/utils/sortByYearQuarter';

export function getIsValidCurrentPeriod<T>({
  data = [],
  cubeName,
  year,
  quarter,
}: {
  data: Record<string, T>[];
  cubeName: string;
  year: number;
  quarter: number;
}): boolean {
  if (!data.length) return false;
  const availablePeriods = [
    ...new Set(
      data.map(item => JSON.stringify({ year: item[`${cubeName}.year`], quarter: item[`${cubeName}.quarter`] })),
    ),
  ].map(item => JSON.parse(item));
  const [current] = sortByYearQuarter(availablePeriods, year, quarter);
  return current && current.year === year && (isAllQuarters(quarter) || current.quarter === quarter);
}
